import { useState } from 'react';

import { useGlobalContext } from '../../contexts/globalContext';
import { CopyButton } from '../../components/buttons/CopyButton';

import logo from '../../assets/logo.svg';
import { Button } from '../../components';
import { CheckBox } from '../../components/forms/CheckBox';
import { Link, useNavigate } from 'react-router-dom';
import { fetchApi } from '../../utils/fetchApi';

const NOTION_INSTRUCTIONS_URL =
  'https://support.mosey.com/kb/rippling-mosey-employee-report-integration';

export const RipplingConnectView = () => {
  const {
    globalState: {
      user: {
        legal_entity: { id: publicId },
      },
    },
  } = useGlobalContext();
  const moseyEmail = `${publicId}@imports.mosey.com`;
  const [isChecked, setIsChecked] = useState(false);
  const [isSaving, setIsSaving] = useState(false);
  const navigate = useNavigate();

  const onProceed = async () => {
    setIsSaving(true);
    await fetchApi({
      url: `/api/connections`,
      method: 'POST',
      body: { integration_slug: 'rippling-csv' },
    });
    setIsSaving(false);
    navigate('/settings/integrations');
  };

  return (
    <div className="absolute left-0 top-0 z-50 flex min-h-screen w-screen items-center justify-center bg-white px-4 py-12 sm:px-6 lg:px-8">
      <div className="w-sm flex min-h-full max-w-sm flex-1 flex-col items-start px-6 py-12">
        <img className="w-24" src={logo} alt="Mosey" />
        <h2 className="mt-10 text-center text-2xl font-bold leading-9 tracking-tight text-gray-900">
          Connect Rippling
        </h2>
        <p className="mb-8 mt-1 text-sm text-gray-600">
          To connect your Rippling account to Mosey, follow the{' '}
          <a
            href={NOTION_INSTRUCTIONS_URL}
            className="font-semibold text-teal-700 hover:text-teal-800"
            target="_blank"
            rel="noreferrer noopener"
          >
            instructions here
          </a>{' '}
          and reference your reports email below.
        </p>
        <p className="font-semibold leading-6 text-gray-900">
          Mosey reports email:
        </p>
        <div className="relative mb-8 flex w-full items-center justify-between gap-2 whitespace-nowrap">
          <p className="text-sm text-gray-600">{publicId}@imports.mosey.com</p>
          <CopyButton textToCopy={moseyEmail} />
        </div>
        <CheckBox
          label="I completed the instructions"
          id="rippling-complete"
          inputProps={{
            checked: isChecked,
            onChange: () => setIsChecked((c) => !c),
          }}
        />

        <div className="flex w-full justify-center gap-4">
          <div className="flex-1">
            <Button
              variant="secondary"
              to="/onboarding/setup"
              as={Link}
              isFullWidth
            >
              Back
            </Button>
          </div>
          <div className="flex-1">
            <Button
              variant="primary"
              isDisabled={!isChecked || isSaving}
              onClick={onProceed}
              isLoading={isSaving}
              isFullWidth
            >
              Continue
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};
